(() => {
  const swRoutes = {
      uv: ['/network/sw.js', '/network/sw-blacklist.js'],
      sj: [
        '/worker/working.sw.js',
        '/worker/working.sw-blacklist.js'
      ],
    },
    swAllowedHostnames = ['localhost', '127.0.0.1'],
    defaultWispUrl =
      (location.protocol === 'https:' ? 'wss' : 'ws') +
      '://' +
      location.host +
      '/cron/',
    proxyUrl = {
      tor: 'socks5h://localhost:9050',
      eu: 'socks5h://localhost:7000',
      jp: 'socks5h://localhost:7001',
    },
    transports = {
      'epoch': '/epoch/index.mjs',
      'unix': '/unix/index.mjs',
    },
    storageId = 'net-time-storage',
    moddedStorageId = 'net-time-modded',
    storageObject = () => JSON.parse(localStorage.getItem(storageId)) || {},
    moddedStorage = () => JSON.parse(localStorage.getItem(moddedStorageId)) || {},
    readStorage = (name) => storageObject()[name],
    readModded = (name) => moddedStorage()[name],
    defaultMode = 'unix';

  transports.default = transports[defaultMode];

  Object.freeze(transports);

  // Get Wisp URL - supports custom Wisp from settings
  const getWispUrl = () => {
    const useCustomWisp = readModded('useCustomWisp');
    const customWispUrl = readModded('customWispUrl');
    
    if (useCustomWisp && customWispUrl) {
      console.log('Using custom Wisp URL:', customWispUrl);
      return customWispUrl;
    }
    return defaultWispUrl;
  };

  const registerSW = async () => {
    if (!navigator.serviceWorker) {
      if (
        location.protocol !== 'https:' &&
        !swAllowedHostnames.includes(location.hostname)
      )
        throw new Error('Service workers cannot be registered without https.');

      throw new Error("Your browser doesn't support service workers.");
    }

    // Set the transport mode
    const transportMode =
      transports[readStorage('Transport')] || transports.default;
    let transportOptions = { wisp: getWispUrl() };

    // Socks5 proxy options
    if ('string' === typeof readStorage('UseSocks5'))
      transportOptions.proxy = proxyUrl[readStorage('UseSocks5')];

    console.log('Using proxy:', transportOptions.proxy);
    console.log('Transport mode:', transportMode);
    console.log('Wisp URL:', transportOptions.wisp);

    const connection = new BareMux.BareMuxConnection('/gmt/worker.js');
    await connection.setTransport(transportMode, [transportOptions]);

    const registrations = await navigator.serviceWorker.getRegistrations(),
      usedSW = swRoutes.uv[readStorage('HideAds') !== false ? 1 : 0];

    console.log('Service Worker being registered:', usedSW);

    // Unregister outdated service workers
    for (const registration of registrations)
      if (
        registration.active &&
        new URL(registration.active.scriptURL).pathname !==
          new URL(usedSW, location.origin).pathname
      )
        await registration.unregister();

    await navigator.serviceWorker.register(usedSW);
  };

  const initializeScramjet = async () => {
    try {
      const { ScramjetController } = await $scramjetLoadController();

      const scramjet = new ScramjetController({
        prefix: '/worker/network/',
        files: {
          wasm: '/worker/working.wasm.wasm',
          all: '/worker/working.all.js',
          sync: '/worker/working.sync.js',
        },
        flags: {
          rewriterLogs: false,
          naiiveRewriter: false,
          scramitize: false,
        },
      });

      console.log('Initializing ScramjetController');
      scramjet.init();
      navigator.serviceWorker.register(
        swRoutes.sj[readStorage('HideAds') !== false ? 1 : 0]
      );
    } catch (err) {
      console.error('Scramjet initialization failed:', err);
    }
  };

  const initialize = async () => {
    try {
      await registerSW();

      await initializeScramjet();
    } catch (err) {
      console.error('Initialization failed:', err);
    }
  };

  initialize();
})();
